import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09e64137"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["accept", "name", "id", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "drop-icon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sign-in fa-rotate-90 fa-6x" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "control"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "status" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin fa-2x" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-2x error" }, null, -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['file-drag-and-drop', _ctx.disabled ? 'disabled' : '']),
    onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "drop-panel",
      onDrop: _cache[4] || (_cache[4] = (...args) => (_ctx.droppedFiles && _ctx.droppedFiles(...args))),
      onDragover: _cache[5] || (_cache[5] = (...args) => (_ctx.dragover && _ctx.dragover(...args))),
      onDragleave: _cache[6] || (_cache[6] = (...args) => (_ctx.dragleave && _ctx.dragleave(...args)))
    }, [
      _createElementVNode("input", {
        type: "file",
        style: {"display":"none"},
        ref: "fileSelector",
        multiple: "",
        accept: _ctx.acceptedFileTypesOnInput,
        name: 'file-input'+_ctx.id,
        id: 'file-input'+_ctx.id,
        onChange: _cache[0] || (_cache[0] = (...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
        disabled: _ctx.disabled
      }, null, 40, _hoisted_1),
      (!_ctx.error && !_ctx.uploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (!_ctx.error && !_ctx.uploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!_ctx.uploading && !_ctx.error && _ctx.selectedFiles.length == 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", {
                    class: "text-btn",
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.selectFile && _ctx.selectFile(...args))),
                    tabindex: "0"
                  }, "Choose a file"),
                  _createTextVNode(" "),
                  (_ctx.dragAndDropCapable)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "or drag it here."))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.disabled)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "disabled-message", {}, undefined, true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedFiles.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.selectedFiles.length) + " file(s) selected ", 1),
                  _createElementVNode("span", {
                    style: {"flex":"1 100%"},
                    class: "text-btn",
                    onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.tryAgain && _ctx.tryAgain(...args))),
                    tabindex: "0"
                  }, "Clear")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.uploading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_10,
              _createTextVNode("  Uploading... ")
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_11,
              _createTextVNode("  " + _toDisplayString(_ctx.errorMsg.join(' | ')) + " ", 1),
              _createElementVNode("span", {
                style: {"flex":"1 100%"},
                class: "text-btn",
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.tryAgain && _ctx.tryAgain(...args))),
                tabindex: "0"
              }, "Try Again")
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ], 34))
}